import { createBrowserRouter } from 'react-router';
import { ConnectPage } from './features/auth/routes.js';
import { RequireAuth } from './features/auth/RequireAuth.js';
import { PanelPage } from './features/panel/routes/PanelPage.js';
import { LandingRoute } from './features/landing/LandingRoute.js';
import { SettingsPage } from './features/settings/SettingsPage.js';

export const router = createBrowserRouter([
  { path: '/', element: <LandingRoute /> },
  { path: '/auth/connect', element: <ConnectPage /> },
  // PanelPage tem checks adicionais (twitch + scopes) — RequireAuth só cobre
  // o gate básico de sessão, deixando regras de domínio dentro da rota.
  { path: '/painel', element: <RequireAuth><PanelPage /></RequireAuth> },
  { path: '/settings', element: <RequireAuth><SettingsPage /></RequireAuth> },
]);
